import index from './pages/index'

const routes = [
    {
        path: '/press',
        name: 'Press',
        component: index
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/press/routes.js